module.exports = __webpack_public_path__ + "static/media/poste_10.b1a8773c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_10.jpg
// module id = 238
// module chunks = 0